import PortalIdParser from 'PortalIdParser';
import { GoogleDataSyncAuthButton } from 'ui-universal-auth/GoogleSignupSyncExperiment';
import { useOneStepDataSync } from '../../hooks/oneStepDataSync';
import { DATA_SYNC_APP_IDS } from '../../constants/dataSyncConstants';
import { completeAllImportOnboardingTasks } from '../../utils/onboardingUtils';
import { DataSyncOptionApp } from '../../constants/types';
import { jsx as _jsx } from "react/jsx-runtime";
const OneClickSyncButton = ({
  app = DataSyncOptionApp.Gmail,
  buttonType = 'selectable',
  children,
  ['data-test-id']: dataTestId,
  onAuthenticationStatusChange = () => {},
  onAuthenticationSuccess = () => {},
  onAuthenticationError = () => {},
  onConnectionError = () => {},
  onClick = () => {}
}) => {
  const setupAndEnableGoogleSync = useOneStepDataSync({
    app,
    onComplete: () => {
      onAuthenticationStatusChange(false);
      // TODO: This is a no-op until we centralize Sentry reporting to this project
      // See: https://git.hubteam.com/HubSpot/GrowthOnboardingPlanningSetup/issues/4047
      completeAllImportOnboardingTasks().catch(() => {});
      onAuthenticationSuccess();
    }
  });
  return /*#__PURE__*/_jsx(GoogleDataSyncAuthButton, {
    buttonType: buttonType,
    "data-test-id": dataTestId,
    use: "primary",
    loginStatus: "completed",
    portalId: PortalIdParser.get(),
    onSuccess: accountId => {
      setupAndEnableGoogleSync(accountId).catch(error => {
        onAuthenticationStatusChange(false);
        onConnectionError(error, accountId, DATA_SYNC_APP_IDS[app]);
      });
    },
    onFailure: error => {
      onAuthenticationStatusChange(false);
      onAuthenticationError(error);
    },
    onClick: event => {
      onAuthenticationStatusChange(true);
      onClick(event);
    },
    children: children
  });
};
export default OneClickSyncButton;